module.exports = __webpack_public_path__ + "static/media/bandcamp.bd01d0a8.svg";